import { Map } from 'immutable';
import { all, call, fork, put, takeEvery, select } from 'redux-saga/effects';

// action creators
import { doneIndicator, success } from 'store/actions/httpActions';

// api
import client from 'sources/api';

// selectors
import getCurrentGroupId from 'store/selectors/getCurrentGroupId';

// constants
import {
  COMMENT_DELETE_REQUEST,
  COMMENT_DELETE,
} from 'store/constants/commentTypes';

// schemas
import { commentSchema } from 'store/schemas/commentSchema';

// helpers
import httpSaga from 'store/sagas/httpSaga';

const WATCH_TYPE = COMMENT_DELETE_REQUEST;
const TYPE = COMMENT_DELETE;

export function* deleteComment(action: any) {
  const {
    payload: { id },
  } = action;

  const currentGroupId = yield select(getCurrentGroupId);

  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  yield* httpSaga(
    TYPE,
    call(client.delete, `/comments/${id}?group_id=${currentGroupId}`),
    {
      dispatchSuccess: false,
      schema: commentSchema,
      metaId: id,
    }
  );

  yield put(success(TYPE, Map({ id })));
  yield put(doneIndicator(TYPE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, deleteComment);
}

export default function* root() {
  yield all([fork(watch)]);
}
